// Fixed exercise content (no AI). French only.

const IMG = {
  pomme: "/illustrations/pomme.jpg",
  banane: "/illustrations/banane.jpg",
  chien: "/illustrations/chien.jpg",
  chat: "/illustrations/chat.jpg",
  fleur: "/illustrations/fleur.jpg",
  maison: "/illustrations/maison.jpg",
};

export const OBJECTS = {
  pomme: { label: "la pomme", img: IMG.pomme },
  banane: { label: "la banane", img: IMG.banane },
  chien: { label: "le chien", img: IMG.chien },
  chat: { label: "le chat", img: IMG.chat },
  fleur: { label: "la fleur", img: IMG.fleur },
  maison: { label: "la maison", img: IMG.maison },
};

export const REWARD_IMG =
  "https://images.unsplash.com/photo-1711234186672-00cfb626ea33?crop=entropy&cs=srgb&fm=jpg&w=800&q=80&ixlib=rb-4.1.0";

export const LOGO = "/logo-pont.png";

export const COMPANION_IMG =
  "https://static.prod-images.emergentagent.com/jobs/ec97d0a1-a465-4f92-b3cb-d4e235ce1143/images/77da1d9b6bbae10f37ef02a05607eb3c459cfdcb0f534ed73311661f6c6270bf.jpeg";

const AGES = [["enfant", "Enfant"], ["ado", "Ado"], ["jeune", "Jeune"], ["adulte", "Adulte"], ["senior", "Senior"]];
export const PORTRAITS = ["femme", "homme"].flatMap((gender) => AGES.map(([age, ageLabel]) => ({
  id: `${gender}-${age}`, label: `${gender === "femme" ? "Femme" : "Homme"} · ${ageLabel}`,
  image: `/illustrations/avatar-${gender}${age === "senior" ? "" : `-${age}`}.jpg`,
})));
export const AVATARS = [PORTRAITS[4].image, PORTRAITS[9].image];

// Memory game pairs (3 pairs = 6 cards)
export const MEMORY_ITEMS = ["pomme", "chien", "fleur"];

// Recognition rounds
export const RECOGNITION_ROUNDS = [
  { answer: "pomme", options: ["pomme", "banane", "fleur"] },
  { answer: "chien", options: ["chat", "chien", "maison"] },
  { answer: "fleur", options: ["maison", "pomme", "fleur"] },
  { answer: "maison", options: ["maison", "chien", "banane"] },
];

// Drag & drop colored shapes -> matching slots
export const DRAG_SHAPES = [
  { id: "rouge", label: "Rouge", color: "#DC2626" },
  { id: "vert", label: "Vert", color: "#047857" },
  { id: "bleu", label: "Bleu", color: "#2563EB" },
];

// Mots fléchés imagés : image indice -> mot à composer
export const PICWORDS = [
  { word: "POMME", img: IMG.pomme, extra: ["R", "S", "L"] },
  { word: "CHIEN", img: IMG.chien, extra: ["A", "O", "T"] },
  { word: "FLEUR", img: IMG.fleur, extra: ["P", "M", "S"] },
  { word: "MAISON", img: IMG.maison, extra: ["R", "T", "E"] },
];

// Sudoku (0 = case vide)
export const SUDOKU_PUZZLES = {
  facile: {
    size: 4,
    box: { rows: 2, cols: 2 },
    given: [
      [1, 2, 0, 4],
      [0, 4, 1, 2],
      [2, 0, 4, 0],
      [4, 3, 0, 1],
    ],
    solution: [
      [1, 2, 3, 4],
      [3, 4, 1, 2],
      [2, 1, 4, 3],
      [4, 3, 2, 1],
    ],
  },
  moyen: {
    size: 6,
    box: { rows: 2, cols: 3 },
    given: [
      [1, 0, 3, 0, 5, 6],
      [0, 5, 6, 1, 0, 3],
      [2, 3, 0, 5, 6, 0],
      [5, 0, 4, 0, 3, 1],
      [3, 1, 0, 6, 0, 5],
      [0, 4, 5, 0, 1, 2],
    ],
    solution: [
      [1, 2, 3, 4, 5, 6],
      [4, 5, 6, 1, 2, 3],
      [2, 3, 1, 5, 6, 4],
      [5, 6, 4, 2, 3, 1],
      [3, 1, 2, 6, 4, 5],
      [6, 4, 5, 3, 1, 2],
    ],
  },
};

// Mots croisés faciles
export const CROSSWORD = {
  rows: 5,
  cols: 5,
  letters: ["C", "H", "A", "T", "F", "E", "R", "O", "M", "S"],
  cells: {
    "1-1": "C", "1-2": "H", "1-3": "A", "1-4": "T",
    "2-1": "A",
    "3-1": "F", "3-2": "E", "3-3": "E",
    "4-1": "E",
  },
  starts: { "1-1": "1", "3-1": "2" },
  clues: [
    { num: "1", dir: "Horizontal", text: "Animal qui miaule (4 lettres)" },
    { num: "1", dir: "Vertical", text: "Boisson chaude du matin (4 lettres)" },
    { num: "2", dir: "Horizontal", text: "Personnage magique des contes (3 lettres)" },
  ],
};

// Jeu des 7 erreurs — image vintage + objets ajoutés à retrouver sur l'image de droite
export const DIFFERENCES = {
  image:
    "https://static.prod-images.emergentagent.com/jobs/ec97d0a1-a465-4f92-b3cb-d4e235ce1143/images/b85901f3ac8d0c3710e160e463c119864acd906e5fc4ea9048c5b74b4a65fce2.jpeg",
  spots: [
    { id: 1, top: 16, left: 10, icon: "Flower2", color: "#DC2626" },
    { id: 2, top: 24, left: 80, icon: "Cat", color: "#7C3AED" },
    { id: 3, top: 60, left: 20, icon: "Heart", color: "#DB2777" },
    { id: 4, top: 68, left: 58, icon: "Leaf", color: "#4A8B6F" },
    { id: 5, top: 14, left: 52, icon: "Bird", color: "#2563EB" },
    { id: 6, top: 46, left: 88, icon: "Bell", color: "#D97706" },
    { id: 7, top: 80, left: 38, icon: "Apple", color: "#DC2626" },
  ],
};

// Tracé au doigt — points à relier dans l'ordre (en %)
export const TRACE_PATH = [
  { x: 10, y: 55 },
  { x: 24, y: 28 },
  { x: 38, y: 58 },
  { x: 52, y: 28 },
  { x: 66, y: 58 },
  { x: 80, y: 28 },
  { x: 92, y: 52 },
];

export const EXERCISES = {
  cognition: [
    { id: "memory", name: "Jeu de mémoire", desc: "Retrouvez les paires identiques" },
    { id: "recognition", name: "Reconnaissance", desc: "Trouvez la bonne image" },
    { id: "picwords", name: "Mots fléchés imagés", desc: "Composez le mot de l'image" },
    { id: "crossword", name: "Mots croisés faciles", desc: "Remplissez la grille avec les bonnes lettres" },
    { id: "sudoku_facile", name: "Sudoku facile", desc: "Grille 4×4 à compléter" },
    { id: "sudoku_moyen", name: "Sudoku moyen", desc: "Grille 6×6 à compléter" },
    { id: "differences", name: "Jeu des 7 erreurs", desc: "Trouvez les 7 objets en trop" },
  ],
  motor: [
    { id: "dragmatch", name: "Glisser les couleurs", desc: "Déplacez chaque pastille au bon endroit" },
    { id: "taptargets", name: "Toucher les ronds", desc: "Touchez chaque rond qui apparaît" },
    { id: "pathtrace", name: "Tracé au doigt", desc: "Suivez le chemin avec le doigt" },
  ],
};

export const EXERCISE_META = {
  memory: { name: "Jeu de mémoire", category: "cognition" },
  recognition: { name: "Reconnaissance", category: "cognition" },
  picwords: { name: "Mots fléchés imagés", category: "cognition" },
  crossword: { name: "Mots croisés faciles", category: "cognition" },
  sudoku_facile: { name: "Sudoku facile", category: "cognition" },
  sudoku_moyen: { name: "Sudoku moyen", category: "cognition" },
  differences: { name: "Jeu des 7 erreurs", category: "cognition" },
  dragmatch: { name: "Glisser les couleurs", category: "motor" },
  taptargets: { name: "Toucher les ronds", category: "motor" },
  pathtrace: { name: "Tracé au doigt", category: "motor" },
};


// Rattachement des exercices intégrés à la nouvelle taxonomie (catégorie → sous-catégorie)
export const BUILTIN_GAMES = [
  { id: "memory", name: "Jeu de mémoire", desc: "Retrouvez les paires identiques", main_category: "alzheimer", sub_name: "Mémoire Procédurale" },
  { id: "recognition", name: "Reconnaissance", desc: "Trouvez la bonne image", main_category: "alzheimer", sub_name: "Reconnaissance" },
  { id: "picwords", name: "Mots fléchés imagés", desc: "Composez le mot de l'image", main_category: "alzheimer", sub_name: "Pictogrammes" },
  { id: "crossword", name: "Mots croisés faciles", desc: "Remplissez la grille", main_category: "alzheimer", sub_name: "Reconnaissance" },
  { id: "sudoku_facile", name: "Sudoku facile", desc: "Grille 4×4 à compléter", main_category: "alzheimer", sub_name: "Motricité Cognitive" },
  { id: "sudoku_moyen", name: "Sudoku moyen", desc: "Grille 6×6 à compléter", main_category: "alzheimer", sub_name: "Motricité Cognitive" },
  { id: "differences", name: "Jeu des 7 erreurs", desc: "Trouvez les 7 objets en trop", main_category: "alzheimer", sub_name: "Familiarité" },
  { id: "dragmatch", name: "Glisser les couleurs", desc: "Déplacez chaque pastille au bon endroit", main_category: "alzheimer", sub_name: "Tri" },
  { id: "taptargets", name: "Toucher les ronds", desc: "Touchez chaque rond qui apparaît", main_category: "alzheimer", sub_name: "Motricité" },
  { id: "pathtrace", name: "Tracé au doigt", desc: "Suivez le chemin avec le doigt", main_category: "alzheimer", sub_name: "Motricité" },
];
